import { Component, OnInit } from '@angular/core';

import { ToastrHelper } from '../../../helpers/toastr.helper';
import { ProjectsService } from '../../../services/projects/projects.service';
import { MatchingProject } from '../../models/matching-project.model';

@Component({
    selector: 'app-feed',
    templateUrl: './feed.component.html',
    styleUrls: ['feed.component.scss'],
})
export class FeedComponent implements OnInit {
    public projects: MatchingProject[];
    public projectsLoaded: boolean;

    constructor(private readonly projectsService: ProjectsService, private readonly toastrHelper: ToastrHelper) {}

    public loadProjects() {
        this.projectsLoaded = false;

        this.projectsService.getMatchedProjects().subscribe(
            (projects) => {
                this.projects = projects;
            },
            (error) => {
                this.toastrHelper.showGenericError(error);
            },
            () => (this.projectsLoaded = true),
        );
    }

    public ngOnInit() {
        this.loadProjects();
    }
}
